import React from "react";
import "./NoRecordFound.scss";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";

const NoRecordFound = ({message}) => {
  return (
    <div className="record-not-found">
      <Image imagePath={AppIcons.noRecordImg} altText="Record Not Found" />
      <h5>{message || `No Data Found`}</h5>
    </div>
  );
}

export default NoRecordFound;
